'use client';
import { zodResolver } from '@hookform/resolvers/zod';
import pickBy from 'lodash/pickBy';
import { FormProvider, type UseFormProps, useForm } from 'react-hook-form';
import type { ZodType } from 'zod';
import { cn } from '../../utils';

export interface FormProps<T extends Record<string, any>> {
  onSubmit: (data: T) => Promise<any> | any;
  schema: ZodType<T>;
  children?: React.ReactNode;
  initialValues?: T;
  options?: UseFormProps;
  className?: string;
}

export function Form<T extends Record<string, any>>(props: FormProps<T>) {
  const getValueShape = (obj?: Record<string, any>) => {
    return pickBy(obj || {}, (v, key) => {
      // TODO might have messed this up
      if ('shape' in props.schema) {
        // biome-ignore lint/suspicious/noPrototypeBuiltins: idk
        return (props.schema as any).shape.hasOwnProperty(key);
      }
      if ('schema' in props.schema._def) {
        // biome-ignore lint/suspicious/noPrototypeBuiltins: idk
        return (props.schema._def as any).schema.shape.hasOwnProperty(key);
      }
    });
  };

  const formProps = useForm<any>({
    defaultValues: {
      ...getValueShape(props.initialValues),
    },
    resolver: props.schema ? zodResolver(props.schema) : undefined,
    ...props.options,
  });

  return (
    <FormProvider {...formProps}>
      <form
        noValidate
        className={cn(props.className)}
        onSubmit={formProps.handleSubmit(props.onSubmit)}
      >
        {props.children}
      </form>
    </FormProvider>
  );
}
